import React from "react";
import { Paper, Typography } from "@mui/material";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import WifiIcon from '@mui/icons-material/Wifi';
import SignalWifiConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiConnectedNoInternet4';
import BoltIcon from '@mui/icons-material/Bolt';
import TextResizer from "./TextResizer";
import PaidIcon from '@mui/icons-material/Paid';
import SatelliteIcon from '@mui/icons-material/Satellite';

const styles = {
  paper: {
    padding: '8px',
    marginTop: "35px",
    maxWidth: '410px',
    minHeight: '135px',
    color: '616e7c'
  },
};

const formatCommas = (number) => {
  return number.toLocaleString('en-US', {maximumFractionDigits:0})
}


const formatNumber = (number) => {
  let parsedNumber = parseFloat(number.replace(/,/g, ''));
  //let parsedNumber = parseFloat(number);
  let dollar=""; 
  let isNegative = false;

  if (number.startsWith('$-')) {
    isNegative = true;
    parsedNumber = parseFloat(number.substring(2));
    isNegative = true;
    dollar = '$';
  }
  else if (number.startsWith('$')) {
    parsedNumber = parseFloat(number.substring(1));
    dollar="$";
  }
  
  if (parsedNumber >= 1e39) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e39).toFixed(1) + ' Duodecillion';
  } else if (parsedNumber >= 1e36) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e36).toFixed(1) + ' Undecillion';
  } else if (parsedNumber >= 1e33) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e33).toFixed(1) + ' Decillion';
  } else if (parsedNumber >= 1e30) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e30).toFixed(1) + ' Nonillion';
  } else if (parsedNumber >= 1e27) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e27).toFixed(1) + ' Octillion';
  } else if (parsedNumber >= 1e24) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e24).toFixed(1) + ' Septillion';
  } else if (parsedNumber >= 1e21) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e21).toFixed(1) + ' Sextillion';
  } else if (parsedNumber >= 1e18) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e18).toFixed(1) + ' Quintillion';
  } else if (parsedNumber >= 1e15) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e15).toFixed(1) + ' Quadrillion';
  } else if (parsedNumber >= 1e12) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e12).toFixed(1) + ' Trillion';
  } else if (parsedNumber >= 1e9) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e9).toFixed(1) + ' Billion';
  } else if (parsedNumber >= 1e6) {
    return (isNegative ? '-' : '') + dollar + (parsedNumber / 1e6).toFixed(1) + ' Million';
  } else {
    //return number;
    let commaNumber = formatCommas(parsedNumber)
    return (isNegative ? '-' : '') + dollar + (commaNumber);
  }
};

const TopCards = (props) => {
  const formattedEarning = formatNumber(props.earning);
  let iconToRender;

  switch (props.icon) {
    case "dollar":
      iconToRender = <PaidIcon style={{ color: 'green' }}/>;
      break;
    case "wallet":
      iconToRender = <AccountBalanceWalletIcon style={{ color: 'green' }}/>;
      break;
    case "money":
      iconToRender = <LocalAtmIcon style={{ color: 'green' }}/>;
      break;
    case "wifi":
      iconToRender = <WifiIcon style={{ color: '#7e57c2' }}/>;
      break;
    case "not_connected":
      iconToRender = <SignalWifiConnectedNoInternet4Icon style={{ color: 'red' }}/>;
      break;
    case "bolt":
      iconToRender = <BoltIcon style={{ color: '42a5f5' }}/>;
      break;
    case "sat":
      iconToRender = <SatelliteIcon style={{ color: 'orange' }}/>;
      break;
    default:
      iconToRender = <AccountBalanceWalletIcon style={{ color: 'green' }}/>;
  }

  return (
    <Paper style={styles.paper} elevation={8}>
      <div className="d-flex">
        {iconToRender}
        <div className="ms-3">
        <TextResizer text={formattedEarning} />
        <Typography variant="subtitle" color="white">
            {props.percent}
          </Typography>
          <Typography variant="subtitle2" color="textSecondary" style={{fontSize:'11px'}}>
            {props.subtitle}
          </Typography>
        </div>
      </div>
    </Paper>
  );
};

export default TopCards;
